import React from 'react';
import './index.css';
import App from './App';
import {SnackBarContextProvider} from "./providers/snackbar-context";
import * as serviceWorker from './serviceWorker';
import * as ReactDOMClient from 'react-dom/client';
import '@nike/podium/styles/core.css';
import '@nike/podium/styles/nike/en-us.css';
import {BrowserRouter} from "react-router-dom";

let imbalanceManagementContainer = null;
let root = null;

///for testing purposes
// let containerId = 'root'
// imbalanceManagementContainer = document.getElementById(containerId);
// root = ReactDOMClient.createRoot(imbalanceManagementContainer);
// root.render(
//     <React.StrictMode>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </React.StrictMode>
// );
///


window.renderImbalanceManagement = (containerId, history, {locationTracker, host, permissions}) => {
    if (!imbalanceManagementContainer) {
        imbalanceManagementContainer = document.getElementById(containerId);
        root = ReactDOMClient.createRoot(imbalanceManagementContainer);
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <SnackBarContextProvider>
                        <App history={history} locationTracker={locationTracker} host={host} permissions={permissions} />
                    </SnackBarContextProvider>
                </BrowserRouter>
            </React.StrictMode>
        );
        serviceWorker.unregister();
    }
};

window.unmountImbalanceManagement = containerId => {
    root.unmount()
    imbalanceManagementContainer = null;
    root = null;
};

if (!document.getElementById('ImbalanceManagement-container')) {
    serviceWorker.unregister();
}
